import { Component, HostBinding, Input } from '@angular/core';

import { AirportComment } from '../models/airport-comment.model';


@Component({
  selector: 'app-remark-list',
  templateUrl: './remark-list.component.html',
  styleUrls: ['./remark-list.component.scss']
})
export class RemarkListComponent {
  @Input() remarks: Array<AirportComment>;
  @Input() compact = false;
  @Input() linkify = true;

  @HostBinding('class.remark-list') private _cls = true;
  @HostBinding('class.remark-list--compact') private get _clsCompact(): boolean {
    return this.compact;
  }
}
